// axios ^1.0.0 express status as a number
// axios ^0.0.0 express status as a string
// as of 2023-11-29, @videoblocks/account-service-client bundles axios ^0 internally, so we cannot use axios.isAxiosError()
export function is404Error(e: unknown): boolean {
    return typeof e === 'object' && !!e && 'status' in e && (e.status === 404 || e.status === '404');
}
